export default "__VITE_ASSET__Cc3ujIv$__"